// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_m-1";
export var movingGradient = "_m-4";
export var movingGradientBlock = "_m-2";
export var skeleton = "_m-0";
export var skeletonText = "_m-3";